import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { HttpClient } from "@angular/common/http";
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import Swal from 'sweetalert2';
import { NavBarMenuService } from 'src/app/shared/topheader/service/nav-bar-menu.service';
import { Navitems } from 'src/app/shared/topheader/Models/navitems.model';
import { AppInsightsService } from 'src/app/services/common/appinsights.service';
import { AppConfigService } from 'src/app/services/appconfig/app-config.service';

@Injectable({
  providedIn: 'root'
})
export class CommonService {
  employeeId: any;

  _baseAPIURL: string;
  private url: string;

  validationMessages = {
    'startDate': {
      'required': 'Required.',
    },
    'endDate': {
      'required': 'Required.',
    }
  };

  formErrors = {
    'startDate': '',
    'endDate': ''
  };
  dtOptionPreview = {//pagingType: 'full_numbers',
    pageLength: 5,
    serverSide: false,
    processing: false,
    destroy: true,
    paging: false,
    searching: false,
    ordering: false,
    lengthChange: false
  };

  constructor(appConfigService: AppConfigService,
    private http: HttpClient,
    private appInsights: AppInsightsService) {
    
    this.url = appConfigService.get('apiUrl');

  }
  getFeatureFlagByName(featureName: any):Observable<any> {
    return this.http.get(this.url + '/Master/GetFeatureFlagByName/' + featureName).pipe(
      map(response => <any>response),
      catchError(response => {
        this.appInsights.logException(response);
        return throwError(response);
      })
    );
  }
 
  }

